// One flash-card run: feed it noteOns, it walks the card queue and produces
// SRS ratings. A clean first pass rates "good"; any miss rates "again" and
// the card stays until it's played correctly (relearn before advancing).

{ type Card, type Matcher, matcherFor } from ./cards.civet
{ type Rating } from ./srs.civet

export type SessionEvent =
  status: "correct" | "wrong" | "progress"
  // set on "wrong": what should have been played
  answer?: string
  // set on "correct": the whole queue is finished
  done?: boolean

export LessonSession := (cards: Card[]) ->
  i .= 0
  missed .= false
  correct .= 0
  incorrect .= 0
  results: {id: string, rating: Rating}[] := []
  matcher: Matcher? .= if cards.length then matcherFor cards[0]

  advance := ->
    i++
    missed = false
    matcher = if i < cards.length then matcherFor cards[i]

  self :=
    current: -> cards[i]
    index: -> i
    total: -> cards.length
    correctCount: -> correct
    incorrectCount: -> incorrect
    results: -> results
    done: -> i >= cards.length

    noteOn: (n: number): SessionEvent ->
      card := cards[i]
      return {status: "progress"} unless card and matcher

      switch matcher.input n
        "wrong"
          // first miss scores the card; the attempt restarts until clean
          unless missed
            missed = true
            incorrect++
          matcher.reset()
          {status: "wrong", answer: card.answer}
        "correct"
          unless missed
            correct++
          results.push {id: card.id, rating: if missed then "again" else "good"}
          advance()
          {status: "correct", done: self.done()}
        else
          {status: "progress"}

  self
